'use client';
import React, { useState } from 'react';
import Link from 'next/link';

import { HamburgerIcon } from '@rescui/icons';

import IaButton from '@/components/common/webteam/IaButton/IaButton';
import IaDropdownMenu from '@/components/common/webteam/IaDropdownMenu/IaDropdownMenu';
import IaMenuItem from '@/components/common/webteam/IaMenuItem/IaMenuItem';
import LoginLogoutButton from '@/components/common/webteam/IaSiteHeader/parts/LoginLogoutButton';
import ProfileButton from '@/components/common/webteam/IaSiteHeader/parts/ProfileButton';
import { useMenuItems } from '@/hooks/menu';

const HeaderMobileMenu: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleIsOpen = () => setIsOpen((s) => !s);

  const menuItems = useMenuItems();

  return (
    <IaDropdownMenu
      isOpen={isOpen}
      theme="dark"
      trigger={
        <IaButton
          icon={<HamburgerIcon />}
          mode="rock"
          size="s"
          theme="dark"
          onClick={toggleIsOpen}
        />
      }
      onRequestClose={() => setIsOpen(false)}
    >
      {menuItems.map(({ title, href }) => (
        <Link href={href} key={href} onClick={toggleIsOpen}>
          <IaMenuItem onClick={toggleIsOpen}>{title}</IaMenuItem>
        </Link>
      ))}

      <ProfileButton onClick={toggleIsOpen} />

      <LoginLogoutButton />
    </IaDropdownMenu>
  );
};

export default HeaderMobileMenu;
